var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInformation = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm.27 4a1 1 0 1 1-1 1 1 1 0 0 1 1-1Zm2 11.75A.25.25 0 0 1 14 18h-3.5a.25.25 0 0 1-.25-.25v-.5a.25.25 0 0 1 .25-.25h.75v-6h-.75a.25.25 0 0 1-.25-.25v-.5a.25.25 0 0 1 .25-.25h2.25a.5.5 0 0 1 .5.5V17H14a.25.25 0 0 1 .25.25Z"
})));
export default SvgInformation;